import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from "react-router-dom";

// import ClientHeader from "../../client-header/components/index";
// import ClientFooter from "../../client-footer/components/index";
import FundraisingHeader from "../layout/header";
import FundraisingFooter from '../layout/footer';
import { fetchFundraisingCategory } from "../slice/fundraisingSlice";

const CapitalCampaign = () => {
    const dispatch = useDispatch();
    // const { id } = useParams();
    const [showDonateModal, setShowDonateModal] = useState(false);

    // useEffect(() => {
    //     dispatch(fetchFundraisingCategory(id));
    // }, [id, dispatch]);

    // const { fundraisingCategories } = useSelector((state) => state.fundraising);

    // console.log("fund", fundraisingCategories);

    const heroFeatures = [
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
                </svg>
            ),
            title: 'Inclusive Early Learning',
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
                </svg>
            ),
            title: 'Early Identification & Support',
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.042A8.967 8.967 0 006 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 016 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 016-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0018 18a8.967 8.967 0 00-6 2.292m0-14.25v14.25" />
                </svg>
            ),
            title: 'Family & Community Resources',
        },
        {
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z" />
                </svg>
            ),
            title: 'Brighter Futures',
        },
    ];

    // Reusable section label pill
    const SectionLabel = ({ children }) => (
        <span
            className="d-inline-flex align-items-center gap-2 rounded-pill fw-semibold mb-3"
            style={{
                background: 'rgba(251,191,36,0.12)',
                color: '#b45309',
                padding: '0.4rem 0.9rem',
                fontSize: '0.72rem',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                border: '1px solid rgba(251,191,36,0.35)',
            }}
        >
            <span className="d-inline-block rounded-circle" style={{ width: 6, height: 6, background: '#f59e0b' }}></span>
            {children}
        </span>
    );

    const SerifHeading = ({ children, className = '', style = {} }) => (
        <h2
            className={`fw-bold mb-4 ${className}`}
            style={{
                fontFamily: '"Playfair Display", Georgia, serif',
                lineHeight: 1.1,
                letterSpacing: '-0.015em',
                color: '#0f172a',
                ...style,
            }}
        >
            {children}
        </h2>
    );

    const BulletItem = ({ title, text }) => (
        <div className="d-flex gap-3 mt-4">
            <span
                className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                style={{
                    width: 32,
                    height: 32,
                    background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
                    color: '#ffffff',
                    fontSize: '0.85rem',
                    fontWeight: 700,
                    boxShadow: '0 8px 20px -8px rgba(245,158,11,0.6)',
                }}
            >
                ✔
            </span>
            <div>
                <strong className="d-block mb-1" style={{ color: '#0f172a' }}>{title}</strong>
                <span className="lh-lg" style={{ color: '#4b5563' }}>{text}</span>
            </div>
        </div>
    );

    return (
        <>
            <FundraisingHeader />Inclusive Early Childhood Education
            <main className="overflow-hidden" style={{ marginTop: "-35px" }}>

               {/* ================= DONATE MODAL (Custom Controlled) ================= */}
{showDonateModal && (
    <>
        {/* Modal Backdrop */}
        <div 
            className="modal-backdrop fade show" 
            style={{ zIndex: 1050, backgroundColor: 'rgba(0,0,0,0.7)' }}
            onClick={() => setShowDonateModal(false)}
        ></div>

        {/* Modal Container */}
        <div 
            className="modal fade show d-block" 
            tabIndex="-1" 
            style={{ zIndex: 1055, backgroundColor: 'transparent' }}
        >
            <div className="modal-dialog modal-dialog-centered modal-lg">
                <div className="modal-content rounded-4 border-0 shadow-lg" style={{ background: '#fdfaf4' }}>
                    <div className="modal-header border-0 pb-0">
                        <h5 className="modal-title fw-bold" id="donateModalLabel" style={{ fontFamily: '"Playfair Display", serif', fontSize: '2rem', color: '#1e293b' }}>
                            Make a Donation
                        </h5>
                        <button 
                            type="button" 
                            className="btn-close" 
                            onClick={() => setShowDonateModal(false)} 
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body p-4 text-center">
                        <p className="text-muted mb-4">Your generosity helps us build a brighter future.</p>
                        
                        <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: '500px' }}>
                            <givebutter-widget id="prWZRn"></givebutter-widget>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
)}

{/* ================= HERO SECTION ================= */}
<section className="position-relative overflow-hidden d-flex align-items-center" style={{ minHeight: '90vh' }}>
    <img
        src="/assets/images/fundraising/01_capital_campaign_background.jpg"
        alt="Every child belongs"
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{ objectFit: 'cover', objectPosition: 'center', zIndex: 0 }}
    />
    
    {/* Dark Gradient Overlay */}
    <div
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
            background: 'linear-gradient(90deg, rgba(15,23,42,0.95) 0%, rgba(15,23,42,0.85) 50%, rgba(15,23,42,0.4) 100%)',
            zIndex: 1,
        }}
    ></div>
    
    <div
        className="position-absolute bottom-0 start-0 w-100"
        style={{ height: '40%', background: 'linear-gradient(180deg, transparent 0%, rgba(15,23,42,0.9) 100%)', zIndex: 1 }}
    ></div>
    
    <div
        className="position-absolute d-none d-lg-block"
        style={{ width: 500, height: 500, top: '-120px', right: '-120px', background: 'radial-gradient(circle, rgba(251,191,36,0.28) 0%, transparent 65%)', filter: 'blur(30px)', zIndex: 1 }}
    ></div>

    <div className="container position-relative" style={{ zIndex: 2 }}>
        <div className="row align-items-center g-5 py-5">
            <div className="col-lg-7 text-center text-lg-start text-white">
                <span
                    className="d-inline-flex align-items-center gap-2 rounded-pill fw-semibold mb-4"
                    style={{ background: 'rgba(255,255,255,0.15)', color: '#fcd34d', padding: '0.5rem 1rem', fontSize: '0.78rem', letterSpacing: '0.08em', textTransform: 'uppercase', border: '1px solid rgba(255,255,255,0.2)' }}
                >
                    <span className="d-inline-block rounded-circle" style={{ width: 8, height: 8, background: '#fbbf24' }}></span>
                    Capital Campaign 2026
                </span>
                
                <h1
                    className="fw-bold mb-4"
                    style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(2.6rem, 5.4vw, 5.25rem)', lineHeight: 1.02, letterSpacing: '-0.02em', textShadow: '0 2px 30px rgba(0,0,0,0.35)' }}
                >
                    {/* {fundraisingCategories?.data?.title || (<>Every Child <br /><span style={{ color: '#fbbf24' }}>Belongs.</span></>)} */}
                    Every Child <br /><span style={{ color: '#fbbf24' }}>Belongs.</span>
                </h1>
                
                {/* <p className="mb-3 lh-lg" style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', maxWidth: 560 }}>
                    {fundraisingCategories?.data?.campaign_description || `Support the $10 million campaign for a planned inclusive early childhood center at 1485 Johnstons Road in Norfolk's Oakmont North community, for children of every ability and the families who love them.`}
                </p> */}

                <p className="mb-3 lh-lg" style={{ color: 'rgba(255,255,255,0.9)', fontSize: '1.1rem', maxWidth: 560 }}>
                    Support the $10 million campaign for a planned inclusive early childhood center at 1485 Johnstons Road in Norfolk's Oakmont North community, for children of every ability and the families who love them.
                </p>
                
                <p className="mb-5 lh-lg small" style={{ color: 'rgba(255,255,255,0.6)', maxWidth: 560 }}>
                    JGF generally seeks unrestricted campaign gifts. Any legally restricted gift, regardless of donor type, requires a separate written gift agreement and Board approval.
                </p>

                {/* Buttons Container */}
                <div className="d-flex flex-wrap gap-3 justify-content-center justify-content-lg-start mt-4">
                    
                    {/* Donate Now Button (Opens Modal) */}
                    <button
                        type="button"
                        className="btn fw-bold rounded-pill d-inline-flex align-items-center gap-2 border-0"
                        onClick={() => setShowDonateModal(true)} // Use React state
                        style={{ 
                            background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)', 
                            color: '#1f2937', 
                            padding: '1rem 2rem', 
                            fontSize: '1rem', 
                            boxShadow: '0 15px 35px -12px rgba(251,191,36,0.7)', 
                            transition: 'transform 0.2s ease' 
                        }}
                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'translateY(-3px)')}
                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'translateY(0)')}
                    >
                        Donate Now
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                        </svg>
                    </button>

                    <Link to="/ways-to-give" className="text-decoration-none">
                        <button
                            className="btn fw-semibold rounded-pill"
                            style={{ background: 'rgba(255,255,255,0.1)', color: '#ffffff', border: '1.5px solid rgba(255,255,255,0.3)', padding: '1rem 2rem', fontSize: '1rem' }}
                        >
                            Support the Campaign
                        </button>
                    </Link>
                    
                    <Link to="/campaign-contact" className="text-decoration-none">
                        <button
                            className="btn fw-semibold rounded-pill"
                            style={{ background: 'rgba(255,255,255,0.1)', color: '#ffffff', border: '1.5px solid rgba(255,255,255,0.3)', padding: '1rem 2rem', fontSize: '1rem' }}
                        >
                            Request Information
                        </button>
                    </Link>
                </div>
            </div>

            <div className="col-lg-5 d-none d-lg-block">
                <div className="d-flex justify-content-end">
                    <div
                        className="rounded-4 p-4 shadow-lg"
                        style={{
                            background: 'rgba(30, 41, 59, 0.7)', 
                            border: '1px solid rgba(255,255,255,0.15)',
                            maxWidth: 340,
                            width: '100%',
                            color: '#fff'
                        }}
                    >
                        <p className="mb-2 fw-semibold" style={{ fontSize: '0.72rem', letterSpacing: '0.1em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.7)' }}>
                            Facility Capital Campaign
                        </p>
                        <p className="fw-bold mb-3" style={{ fontSize: 'clamp(2rem, 3vw, 2.5rem)', lineHeight: 1.2 }}>
                            $10,000,000
                        </p>
                        <hr style={{ borderColor: 'rgba(255,255,255,0.2)' }} />
                        <div className="d-flex align-items-start gap-3 mt-3">
                            <div className="rounded-3 p-2 d-flex align-items-center justify-content-center" style={{ background: 'rgba(251,191,36,0.15)', color: '#fcd34d', minWidth: 42, minHeight: 42 }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.8">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M8 2v4m8-4v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14H3V6a2 2 0 0 1 2-2Z" />
                                </svg>
                            </div>
                            <div>
                                <p className="small mb-1" style={{ color: 'rgba(255,255,255,0.7)' }}>Commitment target</p>
                                <p className="fw-semibold mb-0 text-white">June 30, 2027</p>
                            </div>
                        </div>
                        <div className="mt-4 pt-3 small" style={{ borderTop: '1px solid rgba(255,255,255,0.15)', color: 'rgba(255,255,255,0.8)' }}>
                            Now accepting contributions
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="row g-0 py-4" style={{ borderTop: '1px solid rgba(255,255,255,0.15)' }}>
            {heroFeatures.map((feature, idx) => (
                <div className="col-6 col-md-3" key={idx}>
                    <div className="d-flex flex-column align-items-center text-center px-3 py-3 h-100">
                        <span className="mb-2" style={{ color: '#fbbf24' }}>{feature.icon}</span>
                        <p className="fw-semibold mb-0 small lh-sm text-white">{feature.title}</p>
                    </div>
                </div>
            ))}
        </div>
    </div>
</section>

                {/* ================= MISSION (Why This Facility Matters) ================= */}
                <section className="py-5" id="mission" style={{ background: '#fdfaf4', paddingTop: '6rem', paddingBottom: '6rem' }}>
                    <div className="container">
                        <div className="row align-items-center g-5">
                            <div className="col-lg-6 order-2 order-lg-1">
                                <SectionLabel>Why This Facility Matters</SectionLabel>

                                <SerifHeading style={{ fontSize: 'clamp(2rem, 3.6vw, 3rem)' }}>
                                    Investing in a <span style={{ color: '#d97706' }}>brighter future</span> for every child.
                                </SerifHeading>

                                <p className="lh-lg mb-3" style={{ color: '#4b5563', fontSize: '1.05rem' }}>
                                    Every child deserves the opportunity to learn, grow, and reach their full potential. JGF envisions a welcoming, inclusive facility where children and families can access educational resources, developmental support, and services designed around their individual needs.
                                </p>

                                {[
                                    { title: 'Inclusive Early Childhood Education', text: 'Create a learning environment where children of different abilities can explore, participate, build friendships, and develop essential skills at their own pace.' },
                                    { title: 'Developmental and Special Needs Support', text: 'Help children access individualized support that recognizes their strengths, responds to their needs, and encourages progress in everyday learning and development.' },
                                    { title: 'Early Identification and Referral Coordination', text: 'Promote awareness of developmental needs and help families navigate appropriate screening, assessments, and referrals to qualified professionals.' },
                                    { title: 'Family Education and Support', text: "Give parents and caregivers access to educational resources, guidance, and opportunities to build confidence in supporting their children's development." },
                                    { title: 'Specialized Learning and Therapy Environments', text: 'Envision thoughtfully designed spaces for learning, developmental activities, and therapeutic services, helping children engage in supportive environments suited to their needs.' },
                                ].map((item, idx) => <BulletItem key={idx} {...item} />)}
                            </div>

                            <div className="col-lg-6 order-1 order-lg-2">
                                <div className="position-relative">
                                    <div
                                        className="position-absolute"
                                        style={{
                                            inset: 0,
                                            background: 'linear-gradient(135deg, #fbbf24 0%, #f97316 100%)',
                                            borderRadius: '62% 38% 55% 45% / 45% 55% 45% 55%',
                                            transform: 'rotate(-5deg) scale(0.98)',
                                            zIndex: 0,
                                            opacity: 0.9,
                                        }}
                                    ></div>
                                    <img
                                        src="/assets/images/how-it-work-img.jpg"
                                        alt="Capital Campaign"
                                        className="position-relative w-100 shadow-lg"
                                        style={{ borderRadius: '62% 38% 55% 45% / 45% 55% 45% 55%', aspectRatio: '1 / 1', objectFit: 'cover', zIndex: 1 }}
                                    />
                                    {/* floating badge */}
                                    <div
                                        className="position-absolute bg-white rounded-4 shadow-lg p-3 px-4"
                                        style={{ bottom: '6%', left: '-4%', zIndex: 2, border: '1px solid rgba(0,0,0,0.04)' }}
                                    >
                                        <p className="fw-bold mb-0" style={{ color: '#0f172a' }}>A family with two decades of licensed early-childhood experience in Hampton Roads, serving 1,376 children and families.</p>
                                        {/* <p className="small text-muted mb-0">A family with two decades of licensed early-childhood experience in Hampton Roads, serving 1,376 children and families.</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ================= VISION (Facility Vision) — dark panel ================= */}

                <section
                    className="py-5 text-white position-relative overflow-hidden"
                    id="drive"
                    style={{
                        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
                        paddingTop: '6rem',
                        paddingBottom: '6rem'
                    }}
                >
                    <div
                        className="position-absolute d-none d-lg-block"
                        style={{
                            width: 550,
                            height: 550,
                            top: '-180px',
                            left: '-180px',
                            background: 'radial-gradient(circle, rgba(251,191,36,0.20) 0%, transparent 65%)',
                            filter: 'blur(30px)'
                        }}
                    ></div>

                    <div
                        className="position-absolute d-none d-lg-block"
                        style={{
                            width: 400,
                            height: 400,
                            bottom: '-140px',
                            right: '-100px',
                            background: 'radial-gradient(circle, rgba(244,114,182,0.15) 0%, transparent 65%)',
                            filter: 'blur(30px)'
                        }}
                    ></div>

                    <div className="container position-relative">
                        <div className="row align-items-center g-5">

                            {/* Image */}
                            <div className="col-lg-6">
                                <div className="position-relative">
                                    <div
                                        className="position-absolute w-100 h-100 rounded-4"
                                        style={{
                                            top: 20,
                                            left: 20,
                                            border: '2px solid rgba(251,191,36,0.5)',
                                            zIndex: 0
                                        }}
                                    ></div>

                                    <img
                                        src="/assets/images/about-img.jpg"
                                        alt="Planned inclusive early childhood center"
                                        className="position-relative img-fluid rounded-4 shadow-lg w-100"
                                        style={{ zIndex: 1 }}
                                    />

                                    {/* Show this caption only if the image is an architectural rendering */}
                                    <p
                                        className="mt-3 mb-0 small"
                                        style={{ color: 'rgba(255,255,255,0.72)' }}
                                    >
                                        Architectural rendering of the planned center at 1485
                                        Johnstons Road; final design may vary.
                                    </p>
                                </div>
                            </div>

                            {/* Content */}
                            <div className="col-lg-6">

                                <span
                                    className="d-inline-flex align-items-center gap-2 rounded-pill fw-semibold mb-3"
                                    style={{
                                        background: 'rgba(251,191,36,0.15)',
                                        color: '#fcd34d',
                                        padding: '0.4rem 0.9rem',
                                        fontSize: '0.72rem',
                                        letterSpacing: '0.1em',
                                        textTransform: 'uppercase',
                                        border: '1px solid rgba(251,191,36,0.35)'
                                    }}
                                >
                                    <span
                                        className="d-inline-block rounded-circle"
                                        style={{
                                            width: 6,
                                            height: 6,
                                            background: '#fbbf24'
                                        }}
                                    ></span>
                                    The Planned Center
                                </span>

                                <h2
                                    className="fw-bold mb-4"
                                    style={{
                                        fontFamily: '"Playfair Display", Georgia, serif',
                                        fontSize: 'clamp(2rem, 3.6vw, 3rem)',
                                        lineHeight: 1.1,
                                        letterSpacing: '-0.015em',
                                        color: '#fff'
                                    }}
                                >
                                    A vision for{' '}
                                    <span style={{ color: '#fbbf24' }}>
                                        learning, growth,
                                    </span>{' '}
                                    and inclusion.
                                </h2>

                                <p
                                    className="lh-lg mb-3"
                                    style={{
                                        color: 'rgba(255,255,255,0.75)',
                                        fontSize: '1.05rem'
                                    }}
                                >
                                    JGF envisions a planned inclusive early childhood center
                                    where children of different abilities and their families
                                    can access educational resources, developmental support,
                                    and opportunities to thrive.
                                </p>

                                {[
                                    {
                                        title: 'An Inclusive Center',
                                        text: 'The planned center is envisioned as a welcoming environment for children and families, with accessibility, comfort, and inclusion as key considerations.'
                                    },
                                    {
                                        title: 'Educational and Therapeutic Spaces',
                                        text: "The planned center is intended to include proposed spaces for early learning, developmental activities, and therapeutic support, shaped around children's individual needs."
                                    },
                                    {
                                        title: 'Parent and Family Services',
                                        text: 'The planned center aims to support family education, access to helpful resources, and opportunities for parents and caregivers to receive guidance.'
                                    },
                                    {
                                        title: 'Professional Collaboration',
                                        text: 'The planned center envisions opportunities for educators, developmental specialists, therapists, and other qualified professionals to collaborate in supporting children and families.'
                                    },
                                    {
                                        title: 'Development Milestones',
                                        text: "JGF will share approved project milestones as they become available, keeping supporters informed about the planned center's progress and next steps."
                                    }
                                ].map((item, idx) => (
                                    <div className="d-flex gap-3 mt-4" key={idx}>
                                        <span
                                            className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0"
                                            style={{
                                                width: 32,
                                                height: 32,
                                                background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
                                                color: '#ffffff',
                                                fontSize: '0.85rem',
                                                fontWeight: 700,
                                                boxShadow: '0 8px 20px -8px rgba(245,158,11,0.6)'
                                            }}
                                        >
                                            ✔
                                        </span>

                                        <div>
                                            <strong className="d-block mb-1 text-white">
                                                {item.title}
                                            </strong>

                                            <span
                                                className="lh-lg"
                                                style={{ color: 'rgba(255,255,255,0.72)' }}
                                            >
                                                {item.text}
                                            </span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>


                {/* ================= WAYS TO GIVE ================= */}
                <section className="py-5" id="how-it-work" style={{ background: '#fdfaf4', paddingTop: '6rem', paddingBottom: '6rem' }}>
                    <div className="container">
                        <div className="text-center mb-5">
                            <SectionLabel>Ways to Give</SectionLabel>
                            <SerifHeading className="mx-auto" style={{ fontSize: 'clamp(2rem, 3.6vw, 3rem)', maxWidth: 720 }}>
                                Be part of the <span style={{ color: '#d97706' }}>vision</span>.
                            </SerifHeading>
                            <p className="mx-auto lh-lg" style={{ color: '#4b5563', maxWidth: 640, fontSize: '1.05rem' }}>
                                Choose the giving path that fits you best — every contribution moves us closer to opening the doors.
                            </p>
                        </div>

                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                            {[
                                { title: 'One-Time Contribution', text: 'Make a single donation to support the facility campaign and help move the project vision forward.' },
                                { title: 'Recurring Contribution', text: 'Consider giving regularly to provide ongoing support for the campaign.' },
                                { title: 'Major-Gift Inquiry', text: 'Connect with the campaign team to discuss a significant contribution aligned with your philanthropic interests.' },
                                { title: 'Naming-Opportunity Inquiry', text: "Express interest in learning about potential naming opportunities, subject to JGF's approval and applicable terms." },
                                { title: 'Corporate Partnership', text: 'Explore how your organization could contribute through a partnership, sponsorship, or other approved arrangement.' },
                                { title: 'Foundation Support', text: 'Foundations interested in supporting inclusive education, child development, and family services can connect with JGF to discuss potential funding opportunities.' },
                                { title: 'In-Kind Contribution', text: "Discuss donating suitable goods, professional services, equipment, or other resources that align with the project's approved needs." },
                            ].map((item, idx) => (
                                <div className="col" key={idx}>
                                    <div
                                        className="card h-100 border-0 rounded-4 bg-white position-relative overflow-hidden"
                                        style={{ boxShadow: '0 20px 40px -25px rgba(15,23,42,0.18)', transition: 'transform 0.25s ease, box-shadow 0.25s ease' }}
                                        onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-6px)'; e.currentTarget.style.boxShadow = '0 30px 50px -25px rgba(15,23,42,0.28)'; }}
                                        onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 20px 40px -25px rgba(15,23,42,0.18)'; }}
                                    >
                                        <div className="card-body p-4">
                                            <div
                                                className="d-flex align-items-center justify-content-center rounded-circle mb-3"
                                                style={{ width: 52, height: 52, background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)', boxShadow: '0 12px 25px -10px rgba(245,158,11,0.7)' }}
                                            >
                                                <span className="fw-bold" style={{ color: '#ffffff' }}>{String(idx + 1).padStart(2, '0')}</span>
                                            </div>
                                            <h4 className="fw-bold mb-2" style={{ color: '#0f172a', fontFamily: '"Playfair Display", serif', fontSize: '1.2rem' }}>
                                                {item.title}
                                            </h4>
                                            <p className="small lh-lg mb-0" style={{ color: '#4b5563' }}>{item.text}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* ================= CAMPAIGN LEADERSHIP ================= */}
                <section className="py-5" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)', paddingTop: '6rem', paddingBottom: '6rem' }}>
                    <div className="container">
                        <div className="row align-items-center g-5">
                            <div className="col-md-7">
                                {/* <SectionLabel  >Campaign Leadership</SectionLabel> */}
                                <span
                                    className="d-inline-flex align-items-center gap-2 rounded-pill fw-semibold mb-3"
                                    style={{ background: 'rgba(251,191,36,0.15)', color: '#fcd34d', padding: '0.4rem 0.9rem', fontSize: '0.72rem', letterSpacing: '0.1em', textTransform: 'uppercase', border: '1px solid rgba(251,191,36,0.35)' }}
                                >
                                    <span className="d-inline-block rounded-circle" style={{ width: 6, height: 6, background: '#fbbf24' }}></span>
                                    Campaign Leadership
                                </span>
                                <h2
                                    className="fw-bold mb-4"
                                    style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(2rem, 3.6vw, 3rem)', lineHeight: 1.1, letterSpacing: '-0.015em', color: '#fff' }}
                                >
                                    Meet our <span style={{ color: '#fbbf24' }}>campaign team</span>
                                </h2>
                                {/* <SerifHeading style={{ fontSize: 'clamp(2rem, 3.6vw, 3rem)' }}>
                                    Meet our <span style={{ color: '#d97706' }}>campaign team</span>.
                                </SerifHeading> */}
                                <p className="lh-lg mb-0 text-white" style={{ fontSize: '1.05rem' }}>
                                    Behind this vision is a team committed to helping children and families access inclusive educational and developmental opportunities. Our campaign team works to engage supporters, build partnerships, and share information about the facility initiative.
                                </p>
                            </div>

                            <div className="col-md-5">
                                <div className="position-relative mx-auto" style={{ maxWidth: 460 }}>
                                    <div
                                        className="position-absolute w-100 h-100"
                                        style={{ background: 'linear-gradient(135deg, #fbbf24 0%, #f97316 100%)', borderRadius: '48% 52% 60% 40% / 55% 45% 55% 45%', transform: 'scale(0.98) rotate(4deg)', zIndex: 0 }}
                                    ></div>
                                    <img
                                        src="/assets/images/testimonials-left-img.jpg"
                                        alt="Founder"
                                        className="position-relative w-100 shadow-lg"
                                        style={{ borderRadius: '48% 52% 60% 40% / 55% 45% 55% 45%', aspectRatio: '1 / 1', objectFit: 'cover', zIndex: 1 }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* ================= CALL TO ACTION ================= */}
                <section className="py-5" style={{ background: '#fdfaf4', paddingTop: '6rem', paddingBottom: '6rem' }}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <div
                                    className="rounded-4 text-center p-5 position-relative overflow-hidden text-white shadow-lg"
                                    style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)' }}
                                >
                                    <div className="position-absolute d-none d-md-block" style={{ width: '55%', height: '100%', top: 0, right: 0, background: 'radial-gradient(circle at 70% 50%, rgba(251,191,36,0.28) 0%, transparent 65%)' }}></div>

                                    <div className="position-relative">
                                        <span
                                            className="d-inline-flex align-items-center gap-2 rounded-pill fw-semibold mb-4"
                                            style={{ background: 'rgba(251,191,36,0.15)', color: '#fcd34d', padding: '0.4rem 0.9rem', fontSize: '0.72rem', letterSpacing: '0.1em', textTransform: 'uppercase', border: '1px solid rgba(251,191,36,0.35)' }}
                                        >
                                            <span className="d-inline-block rounded-circle" style={{ width: 6, height: 6, background: '#fbbf24' }}></span>
                                            Capital Campaign
                                        </span>

                                        <h3
                                            className="fw-bold mb-4"
                                            style={{ fontFamily: '"Playfair Display", Georgia, serif', fontSize: 'clamp(1.9rem, 3.2vw, 2.75rem)', lineHeight: 1.15, letterSpacing: '-0.015em' }}
                                        >
                                            Together, we're moving the <span style={{ color: '#fbbf24' }}>vision forward</span>.
                                        </h3>

                                        <p className="lh-lg mb-5 mx-auto" style={{ color: 'rgba(255,255,255,0.75)', maxWidth: 640, fontSize: '1.05rem' }}>
                                            Support from individuals, families, businesses, and foundations can help advance JGF's facility vision. This section will provide a transparent view of fundraising progress when verified campaign figures are available.
                                        </p>

                                        <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 mb-5">
                                            <Link to="/ways-to-give" className="text-decoration-none">
                                                <button
                                                    className="btn fw-bold rounded-pill d-inline-flex align-items-center gap-2 border-0"
                                                    style={{ background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)', color: '#1f2937', padding: '1rem 2rem', boxShadow: '0 15px 35px -12px rgba(251,191,36,0.7)' }}
                                                >
                                                    Support the Campaign
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2.5">
                                                        <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5L21 12l-7.5 7.5M21 12H3" />
                                                    </svg>
                                                </button>
                                            </Link>

                                        </div>
                                        <p
                                            className="mb-4 lh-lg mx-auto text-center"
                                            style={{
                                                color: 'rgba(255,255,255,0.82)',
                                                fontSize: '1.1rem',
                                                maxWidth: 560
                                            }}
                                        >
                                            JGF generally seeks unrestricted campaign gifts. Any legally restricted
                                            gift, regardless of donor type, requires a separate written gift
                                            agreement and Board approval.
                                        </p>


                                        <div
                                            className="rounded-4 p-4 text-start mx-auto"
                                            style={{
                                                background: 'rgba(255,255,255,0.06)',
                                                backdropFilter: 'blur(15px)',
                                                border: '1px solid rgba(255,255,255,0.12)',
                                                maxWidth: 560
                                            }}
                                        >
                                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
                                                <p
                                                    className="mb-0 fw-semibold small"
                                                    style={{
                                                        letterSpacing: '0.08em',
                                                        textTransform: 'uppercase',
                                                        color: 'rgba(255,255,255,0.65)'
                                                    }}
                                                >
                                                    Facility Capital Campaign
                                                </p>

                                                <span
                                                    className="badge rounded-pill"
                                                    style={{
                                                        background: 'rgba(251,191,36,0.18)',
                                                        color: '#fcd34d',
                                                        fontWeight: 500,
                                                        fontSize: '0.68rem',
                                                        padding: '0.35rem 0.7rem'
                                                    }}
                                                >
                                                    Campaign Goal
                                                </span>
                                            </div>

                                            <p
                                                className="fw-bold mb-3"
                                                style={{
                                                    fontSize: 'clamp(2rem, 4vw, 2.75rem)',
                                                    color: '#fff'
                                                }}
                                            >
                                                $10,000,000
                                            </p>

                                            <div
                                                className="d-flex align-items-start gap-3 pt-3"
                                                style={{
                                                    borderTop: '1px solid rgba(255,255,255,0.15)'
                                                }}
                                            >
                                                <div
                                                    className="rounded-3 p-2 d-flex align-items-center justify-content-center"
                                                    style={{
                                                        background: 'rgba(251,191,36,0.15)',
                                                        color: '#fcd34d',
                                                        minWidth: 42,
                                                        minHeight: 42
                                                    }}
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        width="22"
                                                        height="22"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        stroke="currentColor"
                                                        strokeWidth="1.8"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M8 2v4m8-4v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14H3V6a2 2 0 0 1 2-2Z"
                                                        />
                                                    </svg>
                                                </div>

                                                <div>
                                                    <p
                                                        className="small mb-1"
                                                        style={{ color: 'rgba(255,255,255,0.6)' }}
                                                    >
                                                        Commitment target
                                                    </p>

                                                    <p className="fw-semibold mb-0 text-white">
                                                        June 30, 2027
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <FundraisingFooter />
        </>
    );
};

export default CapitalCampaign;